/** Dashboard summary API call. */
import { apiFetch } from './apiClient';

export const getDashboardMetrics = () => apiFetch('/api/dashboard/metrics', { auth: false });
